import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum OnboardingEventName {
    SUBMIT_DISAPPOINTMENT_LEVEL = "submit_disappointment_level",
}

export type DisappointmentLevel = "very_disappointed" | "somewhat_disappointed" | "not_disappointed";

export class SubmitDisappointmentLevelSurveyEvent extends AmplitudeEvent {
    constructor(disappointmentLevel: DisappointmentLevel) {
        super(OnboardingEventName.SUBMIT_DISAPPOINTMENT_LEVEL);
        this.props = { disappointmentLevel };
    }
}

export class CompletedOnboardingStepEvent extends AmplitudeEvent {
    constructor(props: { isAppBlocked: boolean; stepIndex: number }) {
        super("completed_onboarding_step");
        this.props = props;
    }
}

export class CompletedOnboardingVideoEvent extends AmplitudeEvent {
    constructor() {
        super("completed_onboarding_video");
    }
}
